<template>
    <div v-if="!loading">
        <span v-if="displayAsTabs">
            <v-tabs
                centered
                v-model="tab"
                background-color="transparent"
                color="primary"
                :height="20"
                :show-arrows="false"
                class="mt-5">
                <v-tab
                    v-for="(item, index) in categoryContent"
                    :key="index">
                        {{ $getConst('categoryTabs')[index] }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item
                    v-for="(item, index) in categoryContent"
                    :key="index">
                    <v-card class="link-color"
                        flat>
                        <v-card-text v-if="index === 'info'">
                            <v-row>
                                <v-col class="text-center">
                                    <img
                                        v-if="item.backgroundSeal"
                                        :alt="item.state"
                                        :title="item.state"
                                        :src="asset(item.backgroundSeal)"/>
                                    <h3
                                        v-if="'ASTM' !== categoryContent.info.state"
                                        v-html="item.state"
                                        class="primary--text my-3">
                                    </h3>
                                    <astm-sidebar v-if="isChildCategoryPage">
                                    </astm-sidebar>
                                    <div v-html="stripHtml(item.introText)">
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text v-else-if="index === 'contacts'">
                            <v-row
                                v-for="(results, index) in item"
                                :key="index">
                                <v-col>
                                    <h4 class="primary--text mb-2">{{ results.office }}</h4>
                                    <p class="mb-0">{{ results.name }}</p>
                                    <p class="mb-0" v-if="results.address">{{ results.address }}</p>
                                    <p class="mb-0" v-if="results.address2">{{ results.address2 }}</p>
                                    <p class="mb-0" v-if="results.city && results.state && results.zipcode">{{ results.city }}, {{ results.state }} {{ results.zipcode }}</p>
                                    <p class="mb-0" v-if="results.phone">{{ results.phone }}</p>
                                    <p class="mb-0" v-if="results.fax">{{ results.fax }}</p>
                                    <p class="mb-0" v-if="results.url"><a :href="results.url">{{ results.url }}</a></p>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-text v-else-if="index === 'links'">
                            <v-row
                                dense
                                v-for="(results, index) in item"
                                :key="index">
                                <v-col>
                                    <p class="mb-0"><a :href="results.url" target="_blank">{{ results.title }}</a></p>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </span>
        <span v-else>
            <v-card
                style="background-color: unset;"
                flat>
                <v-card-text v-if="tab === 'info'">
                    <v-row>
                        <v-col class="text-center">
                            <img
                                v-if="categoryContent.info.backgroundSeal"
                                :alt="categoryContent.info.state"
                                :title="categoryContent.info.state"
                                :src="asset(categoryContent.info.backgroundSeal)"/>
                            <h3
                                v-if="'ASTM' !== categoryContent.info.state"
                                v-html="categoryContent.info.state"
                                class="primary--text my-3">
                            </h3>
                            <div v-html="categoryContent.info.introText"></div>
                            <astm-sidebar v-if="isChildCategoryPage && isAstmCompassEnabled()">
                            </astm-sidebar>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-else-if="tab === 'contacts'">
                    <v-row
                        v-for="(results, index) in categoryContent.contacts"
                        :key="index">
                        <v-col>
                            <h4 class="primary--text mb-2">{{ results.office }}</h4>
                            <p class="mb-0">{{ results.name }}</p>
                            <p class="mb-0" v-if="results.address">{{ results.address }}</p>
                            <p class="mb-0" v-if="results.address2">{{ results.address2 }}</p>
                            <p class="mb-0" v-if="results.city && results.state && results.zipcode">{{ results.city }}, {{ results.state }} {{ results.zipcode }}</p>
                            <p class="mb-0" v-if="results.phone">{{ results.phone }}</p>
                            <p class="mb-0" v-if="results.fax">{{ results.fax }}</p>
                            <p class="mb-0" v-if="results.url"><a :href="results.url">{{ results.url }}</a></p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-else-if="tab === 'links'">
                    <v-row
                        dense
                        v-for="(results, index) in categoryContent.links"
                        :key="index">
                        <v-col>
                            <p class="mb-0"><a :href="results.url" target="_blank">{{ results.title }}</a></p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </span>
    </div>
</template>

<script>
    import AstmSidebar from '../astm/Sidebar';
    import {StringUtil} from "../../../util/StringUtil";

    export default {
        props: {
            loading: {
              required: false,
              type: Boolean,
            },
            categoryData: {
                required: false
            }
        },
        components: {
            AstmSidebar
        },
        data() {
          return {
            tab: '',
            isChildCategoryPage: false,
          }
        },
        computed: {
          displayAsTabs() {
            const infoTabs = ['info', 'contacts', 'links'];
            return Object.keys(this.categoryContent).filter(item => infoTabs.includes(item)).length > 1;
          },
          categoryContent() {

            if (typeof this.categoryData === 'object' && this.categoryData !== null) {
              return this.categoryData;
            }

            return {};
          }
        },
        methods: {
          stripHtml(text) {
            return StringUtil.stripTags(text);
          },
          updatePageMeta() {

            const introText = this.categoryContent.info?.introText;

            if (introText) {
              const tag = document.querySelector('meta[name="description"]');

              if (tag) {
                tag.setAttribute('content', introText);
              }
            }
          }
        },
        mounted() {

          this.$watch(() => this.categoryContent, (newVal, oldVal) => {

            if (this.categoryContent.info) {
              this.tab = 'info';
            } else if (this.categoryContent.contacts) {
              this.tab = 'contacts';
            } else {
              this.tab = 'links';
            }

            this.updatePageMeta();

          }, {immediate: true});

          EventBus.listen('location:changed', (data) => {

                /** @type {Location} */
                const loc = data.location;

                // should only be visible when browsing specific standard: /astm-standards/something
                this.isChildCategoryPage = !!loc.pathname.match(/astm-standards\/\w+/);
          });
        }
    }
</script>

<style lang="scss" scoped>
    .v-tab {
        min-width: unset;
        text-transform: unset;
        font-size: 12px;
        padding: 0 10px;
    }
    .v-tabs-items, .v-tabs-items .v-card {
      background: transparent !important;
    }
</style>
